import { Chip, styled } from '@mui/material';

const StyledIndividualityItemValue = styled(Chip)(() => ({
	borderRadius: '8px',
	height: 'auto',

	padding: '4px 8px 2px 8px',

	'& .MuiChip-label': {
		fontWeight: 600,
		letterSpacing: '0.4px',
		padding: 0,

		fontSize: '16px',
		lineHeight: '22.4px',
	},
}));

export default StyledIndividualityItemValue;
